import { useMutation } from "@tanstack/react-query";

import { queryClient, QueryKeys } from "@/api/core";
import { useApi } from "@/hooks";

function useAcceptPolicy() {
  const api = useApi();

  return useMutation({
    mutationFn: ({ policy_id }: { policy_id: string }) =>
      api.patch(`/api/v1/truth/policies/${policy_id}/accept`),
    onSuccess() {
      queryClient.setQueryData(QueryKeys.policies.global, {});
    },
  });
}

export { useAcceptPolicy };
